import useIsLoggedIn from "../../../hooks/use-IsLoggedIn";
import Header from "../../Profile/components/Header";
import PaymentFlow from "./PaymentFlow";

function Payments() {
	const isLoggedIn = useIsLoggedIn();

	return (
		<>
			{/* @ts-expect-error onChangeJobStatus not needed on payments page */}
			<Header isLoggedIn={isLoggedIn} />
			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
				<PaymentFlow />
			</div>
		</>
	);
}

export default Payments;
